import { useParams } from "react-router-dom";

import { useQuery } from "@apollo/client";

import { type AbsoluteRoute, type RouteParams } from "../../core/routes";
import { type GetLensInfoQuery, type GetLensInfoQueryVariables, getLensInfo } from "../../lens/api/queries";
import { type ApolloResult } from "../../shared/models";

export const useLensForUpdate = (): ApolloResult<{
    data: GetLensInfoQuery | undefined;
    lensId: string | undefined;
}> => {
    // Hook is used on both create and update pages. Update route params are superset of create, so noting them as partial here.
    const { lensId } = useParams<Partial<RouteParams[AbsoluteRoute.SUBMIT_LENS_UPDATE]>>();

    const { loading, data, error } = useQuery<GetLensInfoQuery, GetLensInfoQueryVariables>(getLensInfo, {
        skip: !lensId,
        variables: {
            lensId: lensId ?? "",
        },
    });

    return {
        error,
        lensId,
        loading,
        data,
    };
};
